// src/hooks/useNombreClinica.js
// =========================================================================
// 🏥 NOMBRE DE LA CLÍNICA ACTUAL (la del subdominio)
// GET /api/clinica es público: el login también lo necesita. Se pide una sola
// vez por carga de página y se comparte entre componentes.
// Además pone el título de la pestaña: «Mi Clínica · Klyndu».
// =========================================================================
import { useEffect, useState } from 'react';
import api from '../services/api';

let peticion = null;

function cargarClinica() {
    if (!peticion) {
        peticion = api.get('/clinica').catch(() => {
            peticion = null; // reintenta en el siguiente montaje
            return null;
        });
    }
    return peticion;
}

export function useNombreClinica() {
    const [nombre, setNombre] = useState('');

    useEffect(() => {
        let activo = true;
        cargarClinica().then((res) => {
            if (!activo || !res?.nombre) return;
            setNombre(res.nombre);
            document.title = `${res.nombre} · Klyndu`;
        });
        return () => { activo = false; };
    }, []);

    return nombre;
}
